module.exports = {"helmetTitle":"Minha Veloe - VeloeTags","identifiersTitle":"Minhas VeloeTags","identifiersDescription":"Veja abaixo a sua lista de veículos ativados:","btnFollow":"Meus pedidos","btnActivation":"Ativar novo veículo","btnNewTag":"Solicitar VeloeTag","noIdentifierTitle":"Ops","noIdentifierDescription":"Você não tem VeloeTags a serem exibidas."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/DashboardIdentifiersForPartners/data.json
// module id = 2288
// module chunks = 0